window.whatsappMessageList = {
  handler: {}
};

whatsappMessageList.ready = function() {
  var handler;

  handler = {
    initSelector: function() {
      //$('.ui.checkbox').checkbox();
      $('.whatsapp-message.phone.checkbox').on('change', function() {
        $(".select-template.column").show();
      })
    },
    init: function() {
      console.log("Initializing whatsapp message list handler")
      $(".clients-list.column").hide();
      $(".select-template.column").hide();

      handler.initSelector();
    }
  }

  whatsappMessageList.handler = handler;
  handler.init();
}
